import React from 'react';
import { Box, Icon, Link } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import gtmBapComparePaymentsDisplayed from '../../core/gtm/gtmBapComparePaymentsDisplayed';
import themeStyles from './PaymentFaqLink.styles';
import usePaymentCompareModal from './usePaymentCompareModal';
const FaqLinkWrapper = themeStyles.apply(Box, 'PaymentFaqLinkWrapper');
const ComparePaymentLink = themeStyles.apply(Link, 'ComparePaymentLink');
const ComparePaymentOptionsCta = ({ handleGtmComparePayment }) => {
    const { t } = useTranslation();
    const { openModal } = usePaymentCompareModal();
    const compareHandler = () => {
        handleGtmComparePayment();
        gtmBapComparePaymentsDisplayed();
        openModal();
    };
    const paymentFaqLinkLabel = t('Pages.Bap.comparePaymentOptionsButton');
    return (React.createElement(FaqLinkWrapper, null,
        React.createElement(ComparePaymentLink, { href: true, styling: "tertiary2", onClick: compareHandler, "data-testid": "cy-compare-payment-options-cta" },
            React.createElement(Icon, { mr: "3px", name: "compare", iconColor: "blue" }),
            paymentFaqLinkLabel,
            React.createElement(Icon, { ml: "12px", height: "12px", name: "arrowRight", iconColor: "blue" }))));
};
export default ComparePaymentOptionsCta;
